import { isEmpty, mapValues, pickBy } from 'lodash';
import { put, select } from 'redux-saga/effects';
import { createStandardAction } from 'typesafe-actions';

import { selectEntities } from '../selectors';

import updateEntities from './updateEntities';

export type ResetEntitiesFromSocketPayload = {
  key: string;
};

const resetEntitiesFromSocket = createStandardAction('resetEntitiesFromSocket')<ResetEntitiesFromSocketPayload>();

/**
 * Set `$fromSocket: false` for all entities of certain type
 *
 * @param payload.key Resource key for entities we want to reset
 */
export function* sagaResetEntitiesFromSocket(action: ReturnType<typeof resetEntitiesFromSocket>) {
  const {
    payload: { key },
  } = action;

  // @ts-ignore
  const allEntitiesObj = yield select(selectEntities);
  const entitiesFromSocketObj = pickBy(allEntitiesObj[key], '$fromSocket');
  const entitiesObj = mapValues(entitiesFromSocketObj, () => ({ $fromSocket: false }));

  if (!isEmpty(entitiesObj)) {
    yield put(updateEntities({ [key]: entitiesObj }));
  }
}

export default resetEntitiesFromSocket;
